import { Action } from 'redux';

export enum AuthActionType {
	Clear = 'clearAuth',
	Update = 'updateAuth'
}

export type ClearAuthAction = Action<AuthActionType.Clear>;
export type UpdateAuthAction = Action<AuthActionType.Update> & {
	data: string;
};

export type AuthAction = ClearAuthAction | UpdateAuthAction;

export function clearAuth(): ClearAuthAction {
	return { type: AuthActionType.Clear };
}

export function updateAuth(token: string): UpdateAuthAction {
	return {
		data: token,
		type: AuthActionType.Update
	};
}
